// import { browserHistory } from 'react-router';
import _ from 'lodash';
import { routes } from '../api/routes';
import * as analytics from './analytics';
const { tagging } = analytics;
import * as tagDetails from './tag-details';
const { gtmTagDetails } = tagDetails;

let {
	localStorageVar
} = routes;

export function getLocalStorageVar(variableName) {
	var localStrogeObj = localStorage.getItem(variableName);
	localStrogeObj = localStrogeObj?JSON.parse(localStrogeObj):null;
	return localStrogeObj;
}

export function typeOfUser() {
    var typeOfUser = "employee";
    var localStrogeObj = localStorage.getItem(localStorageVar);
    if(localStrogeObj) {
       	localStrogeObj = JSON.parse(localStrogeObj);
        if(isNaN(localStrogeObj.sso)) {
            typeOfUser = "customer";
        }
    }
   	return typeOfUser;
}

window.convertToArrayOfObject = function(obj, groupBy) {
	var list = [],
		key;
	if(obj) {
		if(groupBy) {
			for(key in obj) {
				list.push({
					key: key,
					list: obj[key]
				});
			}
		} else {
			for(key in obj) {
				list.push({
					...obj[key],
					key: key
				});
			}
		}
	}
	return list;
}

export function processPricingResponse(response) {
	if(response && response.responseObject && response.responseObject.items && response.responseObject.items.length > 0) {
		response = JSON.parse(JSON.stringify(response));
		response.responseObject.items.forEach(itm => {
			if(itm.records && itm.records.length > 0) {
				itm.records = _.filter(itm.records, { orderable: "Y"});
				const newPriceMaxSeqNumData = _.maxBy(itm.records.filter(item => item.dtl_stg_operand_calc_code === 'NEWPRICE'), 'seq_num');
				if(newPriceMaxSeqNumData) {
					itm.records = _.orderBy(itm.records, ['seq_num'], ['asc']);
					const updatedRecords = itm.records.filter(item => item.seq_num >= newPriceMaxSeqNumData.seq_num);
					updatedRecords[0].unit_price = newPriceMaxSeqNumData.dtl_stg_operand_value;
					itm.records = updatedRecords;
				}
			}
		});
	}
	return response;
}

export function processPimDataResponse(response) {
	if(response && response.responseObject && response.responseObject.length > 0) {
		response = JSON.parse(JSON.stringify(response));
		response.responseObject.forEach(item => {
			item.relationship_type = typeof(item.relationship_type) === 'string' ? [item.relationship_type] : item.relationship_type;
			item.related_item_number = typeof(item.related_item_number) === 'string' ? [item.related_item_number] : item.related_item_number;
		});
	}
	return response;
}

// Firing virtual page view tag
export function updateTagging(history) {
	const url = history && history.pathname ? history.pathname : null;
	if(url) {
		const currentTagging = tagging.find(tag => url.indexOf(tag.url) === 0);
		window.dataLayer = window.dataLayer || [];
		if(currentTagging) {
			window.dataLayer.push({
				'event': 'virtual-pageview',
				'pageTitle': currentTagging.title,
				'pageURL': currentTagging.url,
			});
			// console.log("#####tagging if : ", currentTagging, window.dataLayer);
		} else {
			window.dataLayer.push({
				'event': 'virtual-pageview',
				'pageTitle': undefined,
				'pageURL': undefined,
			});
			// console.log("#####tagging else : ", currentTagging, window.dataLayer);
		}
	}
}

// Firing gtm tags
export function triggerGTMTag(tagName, attributes = {}) {
	const tag = gtmTagDetails.find(item => item.tagName === tagName);
	window.dataLayer = window.dataLayer || [];
	if (tag) {
		const tagDetails = {
			...tag.tagDetails,
			...attributes,
		};
		window.dataLayer.push(tagDetails);
		// console.log("#####tag : ", tagDetails, window.dataLayer);
	}
}

export function manipulateClipBoardToKeepNumericsOnly(callback, event) {
	const clipboardData = event.clipboardData || window.clipboardData;
	let data = clipboardData.getData('Text');
	data = data.replace(/\D/g, '');
	if (window.clipboardData) {
		clipboardData.setData("Text", data);
	} else {
		clipboardData.setData('text/plain', data);
	}
	event.target.value = data;
	event.preventDefault();
	callback && callback(event);
}

export function checkForTokenAccountByMasterSA(selectedPriceSource, accNum) {
	let accountNumber = accNum;
	let salesAgreementNumber = selectedPriceSource.AGREEMENT_NUMBER;
	const quoteType = selectedPriceSource['Quote Type'];
	// 1. check if quoteType is T or U or M 
	// AND
	// 2. Master SA Number should be present
	// AND
	// 3. PRICE_LIST_NAME should be in predefined format. From below we need to pick AccountNumber
	// e.g "QUOTE - %AccountNumber%_SA%Master SA Number%"
	if (
		(quoteType === 'T' || quoteType === 'U' || quoteType === 'M') &&
		selectedPriceSource['Master SA Number'] &&
		selectedPriceSource['PRICE_LIST_NAME']
	) {
		let splittedString = selectedPriceSource['PRICE_LIST_NAME'].split(' - ');
		splittedString = splittedString[1] && splittedString[1].indexOf('_') !== -1 ? splittedString[1].split('_') : null;
		if (splittedString && splittedString[0]) {
			salesAgreementNumber = selectedPriceSource['Master SA Number'];
			accountNumber = splittedString[0];
		}
	}
	return {
		accountNumber,
		salesAgreementNumber
	};
}

// eliminating code as part of WCP-7305

/*export function isCanadianZipCode(zipCode) {
	let flag = false;
	const numericRegex = /^[0-9]*$/;
	if (zipCode && zipCode.indexOf(' ') !== -1 && !numericRegex.test(zipCode)) {
		flag = true;
	}
	return flag;
}*/


// WEBPACK FOOTER //
// ./src/App/redux/util/index.js